export const ETHEREUM = [
    // { icon: '/assets/icons/chains/ethereum.svg', label: 'Ether', value: 'ETH' },
    {
        icon: 'https://raw.githubusercontent.com/Uniswap/assets/master/blockchains/ethereum/assets/0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48/logo.png',
        label: 'USDC Coin',
        value: 'USDC',
    },
    {
        icon: 'https://raw.githubusercontent.com/Uniswap/assets/master/blockchains/ethereum/assets/0xdAC17F958D2ee523a2206206994597C13D831ec7/logo.png',
        label: 'Tether USD',
        value: 'USDT',
    },
    // {
    //   icon: 'https://raw.githubusercontent.com/Uniswap/assets/master/blockchains/ethereum/assets/0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599/logo.png',
    //   label: 'Wrapped BTC',
    //   value: 'WBTC',
    // },
    {
        icon: 'https://raw.githubusercontent.com/Uniswap/assets/master/blockchains/ethereum/assets/0x6B175474E89094C44Da98b954EedeAC495271d0F/logo.png',
        label: 'Dai Stablecoin',
        value: 'DAI',
    },
    // {
    //   icon: 'https://raw.githubusercontent.com/Uniswap/assets/master/blockchains/ethereum/assets/0x4d224452801ACEd8B2F0aebE155379bb5D594381/logo.png',
    //   label: 'ApeCoin',
    //   value: 'APE',
    // },
    {
        icon: 'https://tokens.1inch.io/0x1abaea1f7c830bd89acc67ec4af516284b1bc33c.png',
        label: 'Euro Coin',
        value: 'EUROC',
    },
];

export const POLYGON = [
    {
        icon: 'https://raw.githubusercontent.com/Uniswap/assets/master/blockchains/ethereum/assets/0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48/logo.png',
        label: 'USDC Coin',
        value: 'USDC',
    },
    // {
    //   icon: 'https://raw.githubusercontent.com/Uniswap/assets/master/blockchains/ethereum/assets/0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2/logo.png',
    //   label: 'Wrapped Ether',
    //   value: 'WETH',
    // },
    // {
    //   icon: 'https://raw.githubusercontent.com/Uniswap/assets/master/blockchains/polygon/assets/0x0000000000000000000000000000000000001010/logo.png',
    //   label: 'Polygon Matic',
    //   value: 'MATIC',
    // },
    // {
    //   icon: 'https://raw.githubusercontent.com/Uniswap/assets/master/blockchains/ethereum/assets/0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599/logo.png',
    //   label: 'Wrapped BTC',
    //   value: 'WBTC',
    // },
    {
        icon: 'https://raw.githubusercontent.com/Uniswap/assets/master/blockchains/ethereum/assets/0xdAC17F958D2ee523a2206206994597C13D831ec7/logo.png',
        label: 'Tether USD',
        value: 'USDT',
    },
    {
        icon: 'https://raw.githubusercontent.com/Uniswap/assets/master/blockchains/ethereum/assets/0x6B175474E89094C44Da98b954EedeAC495271d0F/logo.png',
        label: 'Dai Stablecoin',
        value: 'DAI',
    },
];

export const ARBITRUM = [
    // {
    //   icon: 'data:image/png;base64,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',
    //   label: 'Ether',
    //   value: 'ETH',
    // },
    {
        icon: 'https://raw.githubusercontent.com/Uniswap/assets/master/blockchains/arbitrum/assets/0xFF970A61A04b1cA14834A43f5dE4533eBDDB5CC8/logo.png',
        label: 'USDC Coin',
        value: 'USDC',
    },
    {
        icon: 'https://raw.githubusercontent.com/Uniswap/assets/master/blockchains/arbitrum/assets/0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9/logo.png',
        label: 'Tether USD',
        value: 'USDT',
    },

    /*  {
            icon: 'https://raw.githubusercontent.com/Uniswap/assets/master/blockchains/arbitrum/assets/0xfc5A1A6EB076a2C7aD06eD22C90d7E710E35ad0a/logo.png',
            label: 'GMX',
            value: 'GMX'
        },*/
    // {
    //   icon: 'https://raw.githubusercontent.com/Uniswap/assets/master/blockchains/arbitrum/assets/0x2f2a2543B76A4166549F7aaB2e75Bef0aefC5B0f/logo.png',
    //   label: 'Wrapped BTC',
    //   value: 'WBTC',
    // },
    {
        icon: 'https://raw.githubusercontent.com/Uniswap/assets/master/blockchains/arbitrum/assets/0xDA10009cBd5D07dd0CeCc66161FC93D7c9000da1/logo.png',
        label: 'Dai Stablecoin',
        value: 'DAI',
    },
];

export const BNBCHAIN = [
    {
        icon: 'https://raw.githubusercontent.com/Uniswap/assets/master/blockchains/ethereum/assets/0x4Fabb145d64652a948d72533023f6E7A623C7C53/logo.png',
        label: 'Binance USD',
        value: 'BUSD',
    },
    {
        icon: 'https://raw.githubusercontent.com/Uniswap/assets/master/blockchains/arbitrum/assets/0xFF970A61A04b1cA14834A43f5dE4533eBDDB5CC8/logo.png',
        label: 'USDC Coin',
        value: 'USDC',
    },
    {
        icon: 'https://raw.githubusercontent.com/Uniswap/assets/master/blockchains/arbitrum/assets/0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9/logo.png',
        label: 'Tether USD',
        value: 'USDT',
    },
    {
        icon: 'https://raw.githubusercontent.com/Uniswap/assets/master/blockchains/arbitrum/assets/0xDA10009cBd5D07dd0CeCc66161FC93D7c9000da1/logo.png',
        label: 'Dai Stablecoin',
        value: 'DAI',
    },
    // {
    //   icon: '/assets/icons/coins/dogecoin.webp',
    //   label: 'Dogecoin',
    //   value: 'DOGE',
    // },
    // {
    //   icon: '/assets/icons/chains/binance-light_2.svg',
    //   label: 'BNB',
    //   value: 'BNB',
    // },
    // {
    //   icon: '/assets/icons/coins/polkadot.png',
    //   label: 'Polkadot',
    //   value: 'DOT',
    // },
];

export const OPTIMSM = [
    // {
    //   icon: 'data:image/png;base64,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',
    //   label: 'Ether',
    //   value: 'ETH',
    // },
    // {
    //   icon: '/assets/icons/chains/optimism.svg',
    //   label: 'Optimism',
    //   value: 'OP',
    // },
    {
        icon: 'https://raw.githubusercontent.com/Uniswap/assets/master/blockchains/arbitrum/assets/0xFF970A61A04b1cA14834A43f5dE4533eBDDB5CC8/logo.png',
        label: 'USDC Coin',
        value: 'USDC',
    },
    {
        icon: 'https://raw.githubusercontent.com/Uniswap/assets/master/blockchains/arbitrum/assets/0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9/logo.png',
        label: 'Tether USD',
        value: 'USDT',
    },
    {
        icon: 'https://raw.githubusercontent.com/Uniswap/assets/master/blockchains/arbitrum/assets/0xDA10009cBd5D07dd0CeCc66161FC93D7c9000da1/logo.png',
        label: 'Dai Stablecoin',
        value: 'DAI',
    },
];

export enum CHAIN_ID {
    ETHEREUM = 1,
    OPTIMISM = 10,
    POLYGON = 137,
    ARBITRUM = 42161,
    BNB_CHAIN = 56,
    BASE = 8453
}

export const NETWORKS: Network[] = [
    {
        iconUri: '/assets/icons/chains/ethereum.svg',
        name: 'ethereum',
        title: 'Ethereum',
        chainId: CHAIN_ID.ETHEREUM,
        coins: ETHEREUM,
        filteredTokens: [
            {
                'logoURI': 'https://tokens.1inch.io/0x1abaea1f7c830bd89acc67ec4af516284b1bc33c.png',
                'name': 'Euro Coin',
                address: '0x1abaea1f7c830bd89acc67ec4af516284b1bc33c', symbol: 'EUROC'
            },
            {
                'logoURI': 'https://static.debank.com/image/coin/logo_url/usdc/e87790bfe0b3f2ea855dc29069b38818.png',
                'name': 'USD Coin',
                address: '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48', symbol: 'USDC'
            },
            {
                'logoURI': 'https://static.debank.com/image/eth_token/logo_url/0x6c3ea9036406852006290770bedfcaba0e23a0e8/b260fc977773cacaa985a463ea5bbb4a.png',
                'name': 'PayPal USD',
                address: '0x6c3ea9036406852006290770bedfcaba0e23a0e8', symbol: 'PYUSD',
            },
            {
                'logoURI': 'https://static.debank.com/image/eth_token/logo_url/0x6b175474e89094c44da98b954eedeac495271d0f/549c4205dbb199f1b8b03af783f35e71.png',
                'name': 'Dai Stablecoin',
                address: '0x6b175474e89094c44da98b954eedeac495271d0f', symbol: 'DAI'
            },
            {
                'name': 'Tether USD',
                address: '0xdac17f958d2ee523a2206206994597c13d831ec7', symbol: 'USDT',
                'logoURI': 'https://static.debank.com/image/coin/logo_url/usdt/23af7472292cb41dc39b3f1146ead0fe.png',

            },
            {
                'logoURI': 'https://static.debank.com/image/token/logo_url/eth/935ae4e4d1d12d59a99717a24f2540b5.png',
                'name': 'Ether',
                address: '0x0000000000000000000000000000000000000000', symbol: 'ETH',
            },
            {
                'name': 'Wrapped Ether',
                'logoURI': 'https://static.debank.com/image/eth_token/logo_url/0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2/61844453e63cf81301f845d7864236f6.png',
                address: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2', symbol: 'WETH',
            }, {
                'logoURI': 'https://static.debank.com/image/eth_token/logo_url/0x2260fac5e5542a773aa44fbcfedf7c193bc2c599/d3c52e7c7449afa8bd4fad1c93f50d93.png',
                address: '0x2260fac5e5542a773aa44fbcfedf7c193bc2c599', symbol: 'WBTC', name: 'Wrapped BTC'
            }, {
                'logoURI': 'https://static.debank.com/image/eth_token/logo_url/0x514910771af9ca656af840dff83e8264ecf986ca/69425617db0ef93a7c21c4f9b81c7ca5.png',
                address: '0x514910771af9ca656af840dff83e8264ecf986ca', symbol: 'LINK', name: 'Chainlink',
            }, {
                'logoURI': 'https://static.debank.com/image/eth_token/logo_url/0x1f9840a85d5af5bf1d1762f925bdaddc4201f984/fcee0c46fc9864f48ce6a40ed1cdd135.png',
                address: '0x1f9840a85d5af5bf1d1762f925bdaddc4201f984', symbol: 'UNI', name: 'Uniswap',
            }, {
                'logoURI': 'https://static.debank.com/image/eth_token/logo_url/0x0d8775f648430679a709e98d2b0cb6250d2887ef/c5913bbde8a620ce2a47d8c4694e7dbb.png',
                'name': 'Basic Attention Token',
                address: '0x0d8775f648430679a709e98d2b0cb6250d2887ef', symbol: 'BAT',
            }, {
                'logoURI': 'https://static.debank.com/image/eth_token/logo_url/0xc00e94cb662c3520282e6f5717214004a7f26888/dd174d3d7083fa027a433dc50edaf0bc.png',
                address: '0xc00e94cb662c3520282e6f5717214004a7f26888', symbol: 'COMP', name: 'Compound',
            }, {
                'logoURI': 'https://static.debank.com/image/eth_token/logo_url/0xc18360217d8f7ab5e7c516566761ea12ce7f9d72/034d454d78d7be7f9675066fdb63e114.png',
                'name': 'Ethereum Name Service',
                address: '0xc18360217d8f7ab5e7c516566761ea12ce7f9d72', symbol: 'ENS',
            }, {
                'logoURI': 'https://static.debank.com/image/eth_token/logo_url/0x5a98fcbea516cf06857215779fd812ca3bef1b32/3a1a90da5ccd4849de3e83755f1fd8b5.png',
                'name': 'Lido DAO Token',
                address: '0x5a98fcbea516cf06857215779fd812ca3bef1b32', symbol: 'LDO',
            }, {
                'logoURI': 'https://static.debank.com/image/eth_token/logo_url/0x0f5d2fb29fb7d3cfee444a200298f468908cc942/c83dcbf8bae0f6cd1e31c6e176ce5155.png',
                'name': 'Decentraland',
                address: '0x0f5d2fb29fb7d3cfee444a200298f468908cc942', symbol: 'MANA',
            }, {
                'logoURI': 'https://static.debank.com/image/eth_token/logo_url/0x45804880de22913dafe09f4980848ece6ecbaf78/c67db744859c16615fa81fcb3a71b3ae.png',
                'name': 'PAX Gold',
                address: '0x45804880de22913dafe09f4980848ece6ecbaf78', symbol: 'PAXG',
            }
        ]
    },
    {
        iconUri: '/assets/icons/chains/polygon.svg',
        name: 'polygon',
        title: 'Polygon',
        chainId: CHAIN_ID.POLYGON,
        coins: POLYGON,
        filteredTokens: [{
            'address': '0x0000000000000000000000000000000000000000',
            'symbol': 'MATIC',
            'name': 'MATIC',
            'logoURI': 'https://static.debank.com/image/matic_token/logo_url/matic/6f5a6b6f0732a7a235131bd7804d357c.png'
        }, {
            'address': '0x3c499c542cEF5E3811e1192ce70d8cC03d5c3359',
            'symbol': 'USDC',
            'name': 'USD Coin',
            'logoURI': 'https://static.debank.com/image/coin/logo_url/usdc/e87790bfe0b3f2ea855dc29069b38818.png'
        },
            {
                'address': '0x2791bca1f2de4661ed88a30c99a7a9449aa84174',
                'symbol': 'USDC',
                'name': 'USD Coin (PoS)',
                'logoURI': 'https://static.debank.com/image/coin/logo_url/usdc/e87790bfe0b3f2ea855dc29069b38818.png'
            }, {
                'address': '0x7ceb23fd6bc0add59e62ac25578270cff1b9f619',
                'symbol': 'WETH',
                'name': 'Wrapped Ether',
                'logoURI': 'https://static.debank.com/image/matic_token/logo_url/0x7ceb23fd6bc0add59e62ac25578270cff1b9f619/61844453e63cf81301f845d7864236f6.png'
            }, {
                'address': '0x3cef98bb43d732e2f285ee605a8158cde967d219',
                'symbol': 'BAT',
                'name': 'Basic Attention Token (PoS)',
                'logoURI': 'https://static.debank.com/image/matic_token/logo_url/0x3cef98bb43d732e2f285ee605a8158cde967d219/3fb78bff44c7aecb72a81e7da2c1b17e.png'
            }, {
                'address': '0x53e0bca35ec356bd5dddfebbd1fc0fd03fabad39',
                'symbol': 'LINK',
                'name': 'ChainLink Token',
                'logoURI': 'https://static.debank.com/image/matic_token/logo_url/0x53e0bca35ec356bd5dddfebbd1fc0fd03fabad39/69425617db0ef93a7c21c4f9b81c7ca5.png'
            }, {
                'address': '0xa1c57f48f0deb89f569dfbe6e2b7f46d33606fd4',
                'symbol': 'MANA',
                'name': '(PoS) Decentraland MANA',
                'logoURI': 'https://static.debank.com/image/matic_token/logo_url/0xa1c57f48f0deb89f569dfbe6e2b7f46d33606fd4/491eefbf587fd3c92abe6e9bf714c276.png'
            }, {
                'address': '0xbbba073c31bf03b8acf7c28ef0738decf3695683',
                'symbol': 'SAND',
                'name': 'SAND',
                'logoURI': 'https://static.debank.com/image/matic_token/logo_url/0xbbba073c31bf03b8acf7c28ef0738decf3695683/81853b2ea8c205afa8ebbdf213637520.png'
            }]
    },
    {
        iconUri: '/assets/icons/chains/arbitrum.svg',
        name: 'arbitrum',
        title: 'Arbitrum',
        chainId: CHAIN_ID.ARBITRUM,
        coins: ARBITRUM,
        filteredTokens: [
            {
                address: '0xaf88d065e77c8cC2239327C5EDb3A432268e5831',
                symbol: 'USDC',
                name: 'USD Coin',
                logoURI: 'https://static.debank.com/image/coin/logo_url/usdc/e87790bfe0b3f2ea855dc29069b38818.png',
            },
            {
                logoURI: 'https://static.debank.com/image/coin/logo_url/usdc/e87790bfe0b3f2ea855dc29069b38818.png',
                address: '0xFF970A61A04b1cA14834A43f5dE4533eBDDB5CC8', symbol: 'USDC',
                name: 'USD Coin (Bridged)',

            },
            {
                logoURI: 'https://static.debank.com/image/arb_token/logo_url/0xda10009cbd5d07dd0cecc66161fc93d7c9000da1/549c4205dbb199f1b8b03af783f35e71.png',
                name: 'Dai Stablecoin',
                address: '0xda10009cbd5d07dd0cecc66161fc93d7c9000da1', symbol: 'DAI'
            },
            {
                name: 'Tether USD',
                logoURI: 'https://static.debank.com/image/coin/logo_url/usdt/23af7472292cb41dc39b3f1146ead0fe.png',
                address: '0xfd086bc7cd5c481dcc9c85ebe478a1c0b69fcbb9', symbol: 'USDT',
            },
            {
                'logoURI': 'https://static.debank.com/image/arb_token/logo_url/arb/d61441782d4a08a7479d54aea211679e.png',
                'name': 'Ether',
                address: '0x0000000000000000000000000000000000000000', symbol: 'ETH',
            },
            {
                address: '0x912ce59144191c1204e64559fe8253a0e49e6548',
                symbol: 'ARB',
                logoURI: 'https://static.debank.com/image/arb_token/logo_url/0x912ce59144191c1204e64559fe8253a0e49e6548/a28d2f37772955e6d96260d4fafe50a7.png',
                name: 'Arbitrum',

            },
            {
                'logoURI': 'https://static.debank.com/image/arb_token/logo_url/0x82af49447d8a07e3bd95bd0d56f35241523fbab1/61844453e63cf81301f845d7864236f6.png',
                'name': 'Wrapped Ether',
                address: '0x82af49447d8a07e3bd95bd0d56f35241523fbab1', symbol: 'WETH',
            }, {
                'name': 'Wrapped BTC',
                'logoURI': 'https://static.debank.com/image/arb_token/logo_url/0x2f2a2543b76a4166549f7aab2e75bef0aefc5b0f/d3c52e7c7449afa8bd4fad1c93f50d93.png',
                address: '0x2f2a2543b76a4166549f7aab2e75bef0aefc5b0f', symbol: 'WBTC',
            }, {
                'name': 'ChainLink Token',
                'logoURI': 'https://static.debank.com/image/arb_token/logo_url/0xf97f4df75117a78c1a5a0dbb814af92458539fb4/ec9f53931b5e0ae59925b2cb3e593df5.png',
                address: '0xf97f4df75117a78c1a5a0dbb814af92458539fb4', symbol: 'LINK',
            }, {
                'logoURI': 'https://static.debank.com/image/arb_token/logo_url/0xfa7f8980b0f1e64a2062791cc3b0871572f1f7f0/78f517acfa1f4f10d87eb1768f15888f.png',
                'name': 'Uniswap',
                address: '0xfa7f8980b0f1e64a2062791cc3b0871572f1f7f0', symbol: 'UNI',
            }, {
                'name': 'GMX',
                'logoURI': 'https://raw.githubusercontent.com/sushiswap/list/master/logos/token-logos/token/gmx.jpg',
                address: '0x590020b1005b8b25f1a2c82c5f743c540dcfa24d', symbol: 'GMX',
            }, {
                'logoURI': 'https://static.debank.com/image/arb_token/logo_url/0x354a6da3fcde098f8389cad84b0182725c6c91de/adc1acf557aaf7702620d640bc44c1aa.png',
                'name': 'Compound',
                address: '0x354a6da3fcde098f8389cad84b0182725c6c91de', symbol: 'COMP',
            }, {
                'name': 'Curve DAO Token',
                'logoURI': 'https://static.debank.com/image/arb_token/logo_url/0x11cdb42b0eb46d95f990bedd4695a6e3fa034978/9f6990ab9d8be30fc1ff159ebf45e638.png',
                address: '0x11cdb42b0eb46d95f990bedd4695a6e3fa034978', symbol: 'CRV'
            }, {
                'name': 'Lido DAO Token',
                'logoURI': 'https://static.debank.com/image/arb_token/logo_url/0x13ad51ed4f1b7e9dc168d8a00cb3f4ddd85efa60/ca70e712bf4b68bd979e825960a63577.png',
                address: '0x13ad51ed4f1b7e9dc168d8a00cb3f4ddd85efa60', symbol: 'LDO',
            }
        ]
    },
    {
        iconUri: '/assets/icons/chains/binance-light_2.svg',
        title: 'BNB Chain',
        name: 'bsc',
        chainId: CHAIN_ID.BNB_CHAIN,
        coins: BNBCHAIN,
        filteredTokens: [{
            'address': '0x0000000000000000000000000000000000000000',
            'symbol': 'BNB',
            'name': 'BNB',
            'logoURI': 'https://static.debank.com/image/bsc_token/logo_url/bsc/8bfdeaa46fe9be8f5cd43a53b8d1eea1.png'
        }, {
            'address': '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c',
            'symbol': 'WBNB',
            'name': 'WBNB',
            'logoURI': 'https://static.debank.com/image/bsc_token/logo_url/0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c/1177dec1b9b7f58a799c3f22d93b04e1.png'
        }, {
            'address': '0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d',
            'symbol': 'USDC',
            'name': 'USD Coin',
            'logoURI': 'https://static.debank.com/image/coin/logo_url/usdc/e87790bfe0b3f2ea855dc29069b38818.png'
        }, {
            'address': '0x1af3f329e8be154074d8769d1ffa4ee058b1dbc3',
            'symbol': 'DAI',
            'name': 'Dai Token',
            'logoURI': 'https://static.debank.com/image/bsc_token/logo_url/0x1af3f329e8be154074d8769d1ffa4ee058b1dbc3/549c4205dbb199f1b8b03af783f35e71.png'
        }, {
            'address': '0xcc42724c6683b7e57334c4e856f4c9965ed682bd',
            'symbol': 'MATIC',
            'name': 'Matic Token',
            'logoURI': 'https://static.debank.com/image/bsc_token/logo_url/0xcc42724c6683b7e57334c4e856f4c9965ed682bd/20aac20baa9069bd39342edd8c5cc801.png'
        }, {
            'address': '0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82',
            'symbol': 'CAKE',
            'name': 'PancakeSwap Token',
            'logoURI': 'https://static.debank.com/image/bsc_token/logo_url/0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82/9003539eb61139bd494b7412b785d482.png'
        }, {
            'address': '0xf8a0bf9cf54bb92f17374d9e9a321e6a111a51bd',
            'symbol': 'LINK',
            'name': 'ChainLink Token',
            'logoURI': 'https://static.debank.com/image/bsc_token/logo_url/0xf8a0bf9cf54bb92f17374d9e9a321e6a111a51bd/69425617db0ef93a7c21c4f9b81c7ca5.png'
        }]
    },
    {
        iconUri: '/assets/icons/chains/optimism.svg',
        name: 'optimism',
        title: 'Optimism',
        chainId: CHAIN_ID.OPTIMISM,
        coins: OPTIMSM,
        filteredTokens: [{
            'address': '0x0000000000000000000000000000000000000000',
            'symbol': 'ETH',
            'name': 'Ether',
            'logoURI': 'https://static.debank.com/image/op_token/logo_url/op/d61441782d4a08a7479d54aea211679e.png'
        }, {
            'address': '0x4200000000000000000000000000000000000006',
            'symbol': 'WETH',
            'name': 'Wrapped Ether',
            'logoURI': 'https://static.debank.com/image/op_token/logo_url/0x4200000000000000000000000000000000000006/61844453e63cf81301f845d7864236f6.png'
        }, {
            'address': '0x0b2C639c533813f4Aa9D7837CAf62653d097Ff85',
            'symbol': 'USDC',
            'name': 'USD Coin',
            'logoURI': 'https://static.debank.com/image/coin/logo_url/usdc/e87790bfe0b3f2ea855dc29069b38818.png'
        },
            {
                'address': '0x7f5c764cbc14f9669b88837ca1490cca17c31607',
                'symbol': 'USDC',
                'name': 'USD Coin (Bridged)',
                'logoURI': 'https://static.debank.com/image/coin/logo_url/usdc/e87790bfe0b3f2ea855dc29069b38818.png'
            }, {
                'address': '0x94b008aa00579c1307b0ef2c499ad98a8ce58e58',
                'symbol': 'USDT',
                'name': 'Tether USD',
                'logoURI': 'https://static.debank.com/image/coin/logo_url/usdt/23af7472292cb41dc39b3f1146ead0fe.png'
            }, {
                'address': '0xda10009cbd5d07dd0cecc66161fc93d7c9000da1',
                'symbol': 'DAI',
                'name': 'Dai Stablecoin',
                'logoURI': 'https://static.debank.com/image/op_token/logo_url/0xda10009cbd5d07dd0cecc66161fc93d7c9000da1/549c4205dbb199f1b8b03af783f35e71.png'
            }, {
                'address': '0x68f180fcce6836688e9084f035309e29bf0a2095',
                'symbol': 'WBTC',
                'name': 'Wrapped BTC',
                'logoURI': 'https://static.debank.com/image/op_token/logo_url/0x68f180fcce6836688e9084f035309e29bf0a2095/d3c52e7c7449afa8bd4fad1c93f50d93.png'
            }, {
                'address': '0x4200000000000000000000000000000000000042',
                'symbol': 'OP',
                'name': 'OPTIMISM',
                'logoURI': 'https://static.debank.com/image/op_token/logo_url/0x4200000000000000000000000000000000000042/029a56df18f88f4123120fdcb6bea40b.png'
            }, {
                'address': '0x350a791bfc2c21f9ed5d10980dad2e2638ffa7f6',
                'symbol': 'LINK',
                'name': 'ChainLink Token',
                'logoURI': 'https://static.debank.com/image/op_token/logo_url/0x350a791bfc2c21f9ed5d10980dad2e2638ffa7f6/69425617db0ef93a7c21c4f9b81c7ca5.png'
            }, {
                'address': '0x8700daec35af8ff88c16bdf0418774cb3d7599b4',
                'symbol': 'SNX',
                'name': 'Synthetix',
                'logoURI': 'https://static.debank.com/image/op_token/logo_url/0x8700daec35af8ff88c16bdf0418774cb3d7599b4/fb568c26c7902169572abe8fa966e791.png'
            }, {
                'address': '0xfdb794692724153d1488ccdbe0c56c252596735f',
                'symbol': 'LDO',
                'name': 'Lido DAO Token',
                'logoURI': 'https://static.debank.com/image/op_token/logo_url/0xfdb794692724153d1488ccdbe0c56c252596735f/ca70e712bf4b68bd979e825960a63577.png'
            }, {
                'address': '0x3c8b650257cfb5f272f799f5e2b4e65093a11a05',
                'symbol': 'VELO',
                'name': 'Velodrome',
                'logoURI': 'https://static.debank.com/image/op_token/logo_url/0x3c8b650257cfb5f272f799f5e2b4e65093a11a05/433c39cc788f0e5e31cb00dddd8b3c53.png'
            }, {
                'address': '0xfe8b128ba8c78aabc59d4c64cee7ff28e9379921',
                'symbol': 'BAL',
                'name': 'Balancer',
                'logoURI': 'https://static.debank.com/image/op_token/logo_url/0xfe8b128ba8c78aabc59d4c64cee7ff28e9379921/52990c207f4001bd9090dfd90e54374a.png'
            }],
    },
    {
        iconUri: '/assets/icons/chains/base.svg',
        name: 'base',
        title: 'Base',
        chainId: CHAIN_ID.BASE,
        coins: [],
        filteredTokens: [{
            'address': '0x0000000000000000000000000000000000000000',
            'symbol': 'ETH',
            'name': 'Ether',
            'logoURI': 'https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2/logo.png'
        }, {
            'address': '0x4200000000000000000000000000000000000006',
            'symbol': 'WETH',
            'name': 'Wrapped Ether',
            'logoURI': 'https://static.debank.com/image/coin/logo_url/eth/d61441782d4a08a7479d54aea211679e.png'
        }, {
            'address': '0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913',
            'symbol': 'USDC',
            'name': 'USD Coin',
            'logoURI': 'https://static.debank.com/image/coin/logo_url/usdc/e87790bfe0b3f2ea855dc29069b38818.png'
        }, {
            'address': '0x50c5725949A6F0c72E6C4a641F24049A917DB0Cb',
            'symbol': 'DAI',
            'name': 'DAI Stablecoin',
            'logoURI': 'https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0x6B175474E89094C44Da98b954EedeAC495271d0F/logo.png'
        }, {
            'address': '0x940181a94A35A4569E4529A3CDfB74e38FD98631',
            'symbol': 'AERO',
            'name': 'Aerodrome',
            'logoURI': 'https://static.debank.com/image/base_token/logo_url/0x940181a94a35a4569e4529a3cdfb74e38fd98631/f02d753bc321dc8ba480f0424a686482.png'
        }, {
            'address': '0x22e6966B799c4D5B13BE962E1D117b56327FDa66',
            'symbol': 'SNX',
            'name': 'Synthetix Network Token'
        },
            {
                'address': '0x9EaF8C1E34F05a589EDa6BAfdF391Cf6Ad3CB239',
                'symbol': 'YFI',
                'name': 'yearn.finance',
                'logoURI': 'https://static.debank.com/image/base_token/logo_url/0x9eaf8c1e34f05a589eda6bafdf391cf6ad3cb239/f14ac7f4efe5c51e1c6b32add3dea10c.png'
            }]
    },
];

export const WALLET_NETWORKS = NETWORKS;
export const NATIVE_TOKEN_ADDRESS = '0x0000000000000000000000000000000000000000';

export interface FilteredToken {
    address: string;
    symbol: string;
    logoURI?: string;
    name: string;
}

export interface Network {
    iconUri: string;
    title: string;
    name: string;
    chainId: number;
    coins: any[];
    filteredTokens: FilteredToken[]
}

